import {Button, Modal} from "react-bootstrap";
import React from "react";
import PropTypes from "prop-types";

export const SVPWarningModal = ({isOpen, handleOnClickCancel, handelOnClickConfirm, title, message}) => {
    return (
        <Modal show={isOpen} onHide={() => handleOnClickCancel(false)} centered={true}>
            <Modal.Header closeButton={true}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => handleOnClickCancel(false)}
                >
                    Cancel
                </Button>
                <Button variant="danger" onClick={handelOnClickConfirm}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
};

SVPWarningModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleOnClickCancel: PropTypes.func.isRequired,
    handelOnClickConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};
